import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../App';
import { useT } from '../i18n';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Switch } from './ui/switch';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';

/*
  Ad-account connections: "Edit" — name and on/off (PUT
  /api/ad-account-connections/{id}). Tokens are never shown or sent from here.
*/
export default function AdAccountEditDialog({ connection, open, onOpenChange, onSaved }) {
  const { t } = useT();
  const [name, setName] = useState('');
  const [active, setActive] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (connection && open) {
      setName(connection.name || '');
      setActive(connection.is_active !== false);
    }
  }, [connection, open]);

  const save = async () => {
    setSaving(true);
    try {
      const r = await axios.put(API + '/ad-account-connections/' + connection.id, { name: name.trim(), is_active: active });
      toast.success(t('Connection saved'));
      if (onSaved) onSaved(r.data);
      onOpenChange(false);
    } catch (e) {
      toast.error((e && e.response && e.response.data && e.response.data.detail) || t('Could not save the connection'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t('Edit connection')}</DialogTitle>
          <DialogDescription>
            {t('Tokens are not shown. To replace a token, use Refresh token or connect the account again.')}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1">
            <Label htmlFor="ad-edit-name">{t('Connection name')}</Label>
            <Input id="ad-edit-name" data-testid="ad-edit-name" value={name} onChange={(e) => setName(e.target.value)} />
            <p className="text-xs text-muted-foreground">{connection ? connection.account_id : ''}</p>
          </div>
          <div className="flex items-center justify-between rounded-md border border-border p-3">
            <div>
              <Label htmlFor="ad-edit-active">{t('Import cost from this account')}</Label>
              <p className="text-xs text-muted-foreground">{t('Off: cost sync skips this account; the connection is kept.')}</p>
            </div>
            <Switch id="ad-edit-active" data-testid="ad-edit-active" checked={active} onCheckedChange={setActive} />
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('Cancel')}
          </Button>
          <Button onClick={save} disabled={saving} data-testid="ad-edit-save">
            {t('Save')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
